<!-- <div style="height:100%;width:100%;overflow-y:auto;margin-top:66px;"> -->
<div id="top">
  <div class="container chart" [ngClass]="query?.orientation">
  
    <!-- REPORT CHARTS -->
  
    <ng-container  *ngIf="pdfData != null && !loading">

      <div class="row">
        <div>Quick links:</div>
        <div *ngFor="let params of attachedReports" class="ml-2">
          <button [id]="'btn-' + getPageLink(params).id" class="nrk-button" (click)="scroll(getPageLink(params).id)" disabled>{{getPageLink(params).title}}</button>
        </div>
      </div>

      <hr>

      <div class="ml-2">
        <!-- <button class="nrk-button" (click)="showCharts = !showCharts; showCharts && !chartsLoaded && reloadData()">{{showCharts ? 'hide charts' : 'show charts'}}</button> -->
        <button class="nrk-button" (click)="showCharts = !showCharts; showCharts && reloadCharts()">{{showCharts ? 'hide charts' : 'show charts'}}</button>
      </div>

      <!-- <div style="text-align: center" *ngIf="showCharts"> -->
      <ngx-loading-spinner [loading]="showCharts && !chartsLoaded"></ngx-loading-spinner>

      <div [ngStyle]="{ textAlign: 'center', display: showCharts ? 'block' : 'none' }" *ngIf="chartsLoaded">
        <table style="width:70em;margin: 0 auto">

          <tr><td>

          <div class="section-title" *ngIf="showChart('ytdChart')">Invoice Comparison (YTD)</div>
          <table style="margin: 0 auto">
            <tr><td>
              <table class="xls-table">
                <tr><th>Start</th><th>End</th><th>Turnover (EUR)</th><th>%</th></tr>
                <tr *ngFor="let y of pdfData.tables.ytd">
                  <td>{{y?.dateFrom}}</td>
                  <td>{{y?.dateTo}}</td>
                  <td style="text-align:right">{{y.data?.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                  <td style="text-align:right">{{(y?.data?.percent || 0) | number : '1.0-0'}} %</td></tr>
              </table>
            </td><td style="width:380px">
              <ngx-customer-chart [options]="pdfData.charts.ytdChart" [size]="[220, 125]"></ngx-customer-chart>
            </td></tr>
          </table>

          </td><td>
          <ng-container>
            <div class="section-title" *ngIf="showChart('last365Chart')">Invoice Comparison (Last 12 Months)</div>
            <table style="margin: 0 auto">
              <tr><td>
                <table class="xls-table">
                  <tr><th>Start</th><th>End</th><th>Turnover (EUR)</th><th>%</th></tr>
                  <tr *ngFor="let y of pdfData.tables.last365">
                    <td>{{y?.dateFrom}}</td>
                    <td>{{y?.dateTo}}</td>
                    <td style="text-align:right">{{y.data?.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                    <td style="text-align:right">{{(y?.data?.percent || 0) | number : '1.0-0'}} %</td></tr>
                </table>
              </td><td style="width:380px">
                <ngx-customer-chart [options]="pdfData.charts.last365Chart"  [size]="[220, 125]"></ngx-customer-chart>
              </td></tr>
            </table>
          </ng-container>
          </td></tr>

          <tr><td>
          <div class="section-title" *ngIf="showChart('thisMonthChart')">Invoice and Open Orders Comparison (Current Month)</div>
          <table style="margin: 0 auto">
            <tr><td>
              <table class="xls-table">
                <tr><th>Start</th><th>End</th><th>IN</th><th>OO</th><th>Total</th><th>%</th></tr>
                <tr *ngFor="let y of pdfData.tables.thisMonth" [ngStyle]="{ 'background-color': y.color || null }">
                  <td>{{y?.dateFrom}}</td>
                  <td>{{y?.dateTo}}</td>
                  <td style="text-align:right">{{y.inNet | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                  <td style="text-align:right;background-color:orange">{{y.ooNet | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                  <td style="text-align:right">{{y.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                  <td style="text-align:right">{{(y.percent || 0) | number : '1.0-0'}} %</td></tr>
                <!-- <tr><th>Start</th><th>End</th><th>Turnover (EUR)</th><th>%</th></tr>
                <tr *ngFor="let y of pdfData.tables.thisMonth" [ngStyle]="{ 'background-color': y.color || null }">
                  <td>{{y?.dateFrom}}</td>
                  <td>{{y?.dateTo}}</td>
                  <td style="text-align:right">{{y.data?.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                  <td style="text-align:right">{{(y?.data?.percent || 0) | number : '1.0-0'}} %</td></tr> -->
              </table>
            </td><td style="width:380px">
              <ngx-customer-chart [options]="pdfData.charts.thisMonthChart" [size]="[220, 125]"></ngx-customer-chart>
            </td></tr>
          </table>

          </td><td>
          <ng-container *ngIf="showChart('thisYearChart')">
            <div class="section-title">Invoice and Open Orders Comparison (Calendar Year)</div>
            <table style="margin: 0 auto">
              <tr><td>
                <table class="xls-table">
                  <tr><th>Start</th><th>End</th><th>IN</th><th>OO</th><th>Total</th><th>%</th></tr>
                  <tr *ngFor="let y of pdfData.tables.thisYear" [ngStyle]="{ 'background-color': y.color || null }">
                    <td>{{y?.dateFrom}}</td>
                    <td>{{y?.dateTo}}</td>
                    <td style="text-align:right">{{y.inNet | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                    <td style="text-align:right;background-color:orange">{{y.ooNet | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                    <td style="text-align:right">{{y.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                    <td style="text-align:right">{{(y.percent || 0) | number : '1.0-0'}} %</td></tr>
                  <!-- <tr><th>Start</th><th>End</th><th>Turnover (EUR)</th><th>%</th></tr>
                  <tr *ngFor="let y of pdfData.tables.thisYear" [ngStyle]="{ 'background-color': y.color || null }">
                    <td>{{y?.dateFrom}}</td>
                    <td>{{y?.dateTo}}</td>
                    <td style="text-align:right">{{y.data?.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                    <td style="text-align:right">{{(y?.data?.percent || 0) | number : '1.0-0'}} %</td></tr> -->
                </table>
              </td><td style="width:380px">
                <ngx-customer-chart [options]="pdfData.charts.thisYearChart"  [size]="[220, 125]"></ngx-customer-chart>
              </td></tr>
            </table>
          </ng-container>
          </td></tr>

          <tr><td colspan="2">
            <div class="section-title" *ngIf="showChart('fiscalYearChart')">Turnover Comparison (Fiscal Year)</div>
            <table style="margin: 0 auto">
              <tr><td>
                <table class="xls-table">
                  <tr><th>Start</th><th>End</th><th>IN</th><th>OO</th><th>Total</th><th>%</th></tr>
                  <tr *ngFor="let y of pdfData.tables.fiscalYear" [ngStyle]="{ 'background-color': y.color || null }">
                    <td>{{y?.dateFrom}}</td>
                    <td>{{y?.dateTo}}</td>
                    <td style="text-align:right">{{y.inNet | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                    <td style="text-align:right;background-color:orange">{{y.ooNet | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                    <td style="text-align:right">{{y.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                    <td style="text-align:right">{{(y.percent || 0) | number : '1.0-0'}} %</td></tr>
                </table>
              </td><td style="width:380px">
                <ngx-customer-chart [options]="pdfData.charts.fiscalYearChart" [size]="[300, 200]"></ngx-customer-chart>
              </td></tr>
            </table>
          </td></tr>

            <!-- <tr><td colspan="2">
            <div class="section-title">Open Orders by Base Product</div>
            <table style="margin: 0 auto">
              <tr><td>
                <table class="xls-table">
                  <tr><th>Start</th><th>End</th><th>Turnover (EUR)</th></tr>
                  <tr *ngFor="let y of pdfData.tables.noninvoiced">
                    <td>{{y?.dateFrom}}</td>
                    <td>{{y?.dateTo}}</td>
                    <td style="text-align:right">{{y.data?.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
                </table>
              </td><td style="width:380px">
                <ngx-customer-chart [options]="pdfData.charts.noninvoicedChart" [size]="[700, 125]"></ngx-customer-chart>
              </td></tr>
            </table>
          </td></tr> -->

        </table>
  
        <div class="no-page-break" *ngIf="showChart('chartOverTime')">
          <div class="section-title">Invoices & Open Orders by Month</div>
          <ngx-customer-chart [options]="pdfData.charts.chartOverTime" [size]="[900, 400]"></ngx-customer-chart>
        </div>

        <div class="no-page-break" *ngIf="showChart('noninvoicedChart')">
          <div class="section-title">Open Orders by Base Product</div>
          <table style="margin: 0 auto">
            <tr><td>
              <table class="xls-table">
                <tr><th>Start</th><th>End</th><th>Turnover (EUR)</th></tr>
                <tr *ngFor="let y of pdfData.tables.noninvoiced">
                  <td>{{y?.dateFrom}}</td>
                  <td>{{y?.dateTo}}</td>
                  <td style="text-align:right">{{y.data?.net | currency : 'EUR' : 'symbol' : '1.2-2' : 'de' }}</td>
              </table>
            </td><td style="width:380px">
              <ngx-customer-chart [options]="pdfData.charts.noninvoicedChart" [size]="[700, 400]"></ngx-customer-chart>
            </td></tr>
          </table>
        </div>
    
        <div class="no-page-break" *ngIf="showChart('issuerChart')">
          <div class="section-title">Turnover by Issuer {{getDateInterval()}}</div>
          <ngx-customer-chart [options]="pdfData.charts.issuerChart"></ngx-customer-chart>
        </div>
  
        <div class="no-page-break" *ngIf="showChart('rsmChart')">
          <div class="section-title">Turnover by RSM {{getDateInterval()}}</div>
          <ngx-customer-chart [options]="pdfData.charts.rsmChart"></ngx-customer-chart>
        </div>
  
        <div class="no-page-break" *ngIf="showChart('countryChart')">
          <div class="section-title">Turnover by Country {{getDateInterval()}}</div>
          <ngx-customer-chart [options]="pdfData.charts.countryChart"></ngx-customer-chart>
        </div>
  
        <div class="no-page-break" *ngIf="showChart('customerChart')">
          <div class="section-title">Turnover by Customer {{getDateInterval()}}</div>
          <ngx-customer-chart [options]="pdfData.charts.customerChart"></ngx-customer-chart>
        </div>
  
        <div class="no-page-break" *ngIf="showChart('businessUnitChart')">
          <div class="section-title">Turnover by Business Unit {{getDateInterval()}}</div>
          <ngx-customer-chart [options]="pdfData.charts.businessUnitChart"></ngx-customer-chart>
        </div>
  
        <div class="no-page-break" *ngIf="showChart('baseProductChart')">
          <div class="section-title">Turnover by Base Product {{getDateInterval()}}</div>
          <ngx-customer-chart [options]="pdfData.charts.baseProductChart" [size]="[700,500]"></ngx-customer-chart>
        </div>
  
        <div class="no-page-break" *ngIf="showChart('finishedProductChart')">
          <div class="section-title">Turnover by Finished Product - Energy Materials only{{getDateInterval()}}</div>
          <ngx-customer-chart [options]="pdfData.charts.finishedProductChart" [size]="[700,600]"></ngx-customer-chart>
        </div>
  
      </div>
  
    </ng-container>
  </div>
  
  <!-- PDF REPORTS -->
  
<ng-container *ngFor="let params of attachedReports" class="attached-reports">
    <div [id]="getPageLink(params).id">
      <hr>
      <div><button class="nrk-button top-button" (click)="scroll('top')">⬆top</button></div>
      <ngx-reports-printer [search]="params" [pdfSidebar]="true" [dashboard]="true" [showButtons]="true" (popupReport)="onPopupReport($event)" (done)="reportLoaded(params)"></ngx-reports-printer>     
      <div style="position:relative;bottom:6em; width:7em"><button class="nrk-button top-button" (click)="rep(params).limit = rep(params)?.limit +  10">next 10</button></div>
    </div>
  </ng-container>
 
</div>
  
  <!-- <div class="page">
    <div class="row">
      <ngx-status class="col-xl-3 col-lg-6 col-md-6" color="dark" title="Gemeldete Schäden" amount="5" raising="true" description="+ 24%"></ngx-status>
      <ngx-status class="col-xl-3 col-lg-6 col-md-6" color="light" title="Aktivierte Companies" amount="85" raising="false" description="- 8.2%"></ngx-status>
      <ngx-status class="col-xl-3 col-lg-6 col-md-6" title="Aktivierte Techniker" amount="400" raising="true" description="+ 2.6%"></ngx-status>
      <ngx-status class="col-xl-3 col-lg-6 col-md-6" color="light" title="verspätete Lieferungen" amount="0" raising="false" description="Zeitraum diese Woche"></ngx-status>
      <ngx-status class="col-xl-3 col-lg-6 col-md-6" title="Sendungen" amount="500" raising="true" description="+Zeitraum diese Woche"></ngx-status>
    </div>
  </div> -->
  
<!-- popup report window -->
<ng-container *ngIf="showPopupReport">
  <ngx-popup-report [searches]="reportData" (close)="showPopupReport=false">  
  </ngx-popup-report>
</ng-container>
